import { EventContentArg } from '@fullcalendar/core';
import { Popover, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import * as React from 'react';
import { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CalendarEvent } from '../../../sic-lib/types/CalendarEvent';
import FullCalendarEventPopoverContent from '../FullCalendarEventPopoverContent/FullCalendarEventPopoverContent';
import MonthCalendarEvent from './MonthCalendatEventContent/MonthCalendarEvent';
import MultilineCalendarEventContent from './MultilineCalendarEventContent/MultilineCalendarEventContent';

const useStyles = makeStyles()(theme => ({
    eventWrapper: {
        height: '100%',
    },
    timeWrapper: {
        fontSize: '',
    },
}));

interface Props {
    fcCalendarEvent: EventContentArg;
    allEvents: Array<CalendarEvent>;
}

export default function FullCalendarEventContent({ fcCalendarEvent, allEvents }: Props) {
    const { classes } = useStyles();

    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
    const [calendarEvent, setCalendarEvent] = React.useState<CalendarEvent<DateTime> | undefined>();

    useEffect(() => {
        console.log('FullCalendarEventContent', fcCalendarEvent, allEvents);
        var cEvent = allEvents.find(x => x.eventId == +fcCalendarEvent.event.id);
        if (cEvent) setCalendarEvent(cEvent);

        return () => {
            setAnchorEl(null);
        };
    }, []);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = `calendar-popover-${fcCalendarEvent.event.id}`;

    return (
        <>
            {!!calendarEvent && (
                <div className={classes.eventWrapper} onClick={handleClick}>
                    {fcCalendarEvent.view.type == 'dayGridMonth' && (
                        <MonthCalendarEvent
                            fcCalendarEvent={fcCalendarEvent}
                            calendarEvent={calendarEvent}
                        />
                    )}
                    {fcCalendarEvent.view.type != 'dayGridMonth' && (
                        <MultilineCalendarEventContent
                            fcCalendarEvent={fcCalendarEvent}
                            calendarEvent={calendarEvent}
                        />
                    )}
                </div>
            )}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
            >
                {!!calendarEvent && (
                    <FullCalendarEventPopoverContent
                        fcCalendarEvent={fcCalendarEvent}
                        calendarEvent={calendarEvent}
                        closePopover={setAnchorEl}
                    />
                )}
                {!calendarEvent && (
                    <Typography component="p" variant="body2">
                        Couldn't load Event Info, please try again after refreshing.
                    </Typography>
                )}
            </Popover>
        </>
    );
}
